import {
  Avatar,
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Img,
  Link,
  List,
  ListItem,
  Text,
} from '@chakra-ui/react';
import React from 'react';
import { FaLinkedin } from 'react-icons/fa';

const TheContextBalancingFounderBlog: React.FC = () => (
  <>
    <Flex
      flexDirection="column"
      overflow="hidden"
      justify="center"
      height="100%"
      py={{ xs: '30px', sm: '40px', md: '60px', lg: '80px' }}
      h="100%"
      minH={{ xs: '400px', lg: '400px' }}
      maxH={{ xs: '400px', lg: '400px' }}
      pos="relative"
    >
      <Img
        pos="absolute"
        objectFit="cover"
        src="/webp/theContext-bg.webp"
        alt="members-hero"
        height="100%"
        width="100%"
      />
      <Box
        bg="linear-gradient(78.35deg, rgba(13, 96, 81, 0.8) 18.38%, rgba(83, 92, 143, 0.8) 86.05%)"
        pos="absolute"
        height="100%"
        width="100%"
        opacity="0.7"
      />
      <Container
        display="flex"
        as="section"
        maxW="container.xl"
        position="relative"
        zIndex="1"
        flexDir={{ xs: 'column', md: 'row' }}
        columnGap="24px"
        rowGap="30px"
        alignItems={{ xs: 'flex-start', md: 'flex-start' }}
        px={{ xs: '14px', sm: '28px', md: '45px', lg: '60px', xl: 'inherit' }}
      >
        <Flex flexDir="column" rowGap="16px">
          <Heading
            color="white"
            fontSize={{ xs: '36px', sm: '42px', lg: '64px' }}
            fontWeight="800"
            lineHeight={{ xs: '35px', lg: '83px' }}
          >
            #TheContext
          </Heading>
        </Flex>
        <Box
          w="1.5px"
          h={{ md: '200px', lg: '300px', xl: '230px' }}
          bgColor="white"
          display={{ xs: 'none', md: 'block' }}
        />
        <Box
          w={{ xs: '70%', sm: '60%' }}
          h="1.5px"
          bgColor="white"
          display={{ xs: 'block', md: 'none' }}
        />
        <Flex flexDir="column" rowGap="8px">
          <Heading
            as="h1"
            mb={{ xs: '10px', md: '20px' }}
            variant="reportCardTitle"
            fontSize={{ xs: '27px', sm: '29px', md: '32px', lg: '54px' }}
            color="white"
            lineHeight={{ xs: '36px', sm: '40px', md: '46px', lg: '70.2px' }}
          >
            Balancing Founder Incentives and Regulatory Changes: The ESOP
            Dilemma in IPOs
          </Heading>
          <Text
            fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
            fontWeight="600"
            color="white"
            lineHeight="28px"
          >
            Nikhil Naredi
          </Text>
          <Text
            fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
            fontWeight="600"
            color="white"
            lineHeight="28px"
          >
            Trishita Dasgupta
          </Text>
          <Text
            fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
            fontWeight="600"
            color="white"
            lineHeight="28px"
          >
            Neha Sahgal
          </Text>
        </Flex>
      </Container>
    </Flex>
    <Container maxW="container.xl" pb="80px" pt="40px">
      <Flex
        flexDir={{ xs: 'column-reverse', md: 'row' }}
        px={{ xs: '8px', md: '0px' }}
      >
        <Flex
          w={{ xs: '100%', md: '27%' }}
          mt={{ xs: '32px', md: '0px' }}
          flexDir="column"
          rowGap="16px"
          mr={{ xs: '0px', md: '40px' }}
          ml={{ xs: '0px', sm: '10px' }}
          mb={{ xs: '16px', md: '8px' }}
        >
          <Heading
            fontSize="22px"
            lineHeight="22px"
            textAlign={{ xs: 'center', sm: 'left' }}
          >
            Follow the Authors
          </Heading>
          <Box
            w="100%"
            h="1.5px"
            bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
            my="8px"
          />
          {[
            {
              name: 'Nikhil Naredi',
              position: 'Partner, Shardul Amarchand Mangaldas & Co',
              image:
                'https://static.levocdn.com/WGLBUT82/NikhilNaredi-GLUIccXCuSGG.jpg',
              linkedIn:
                'https://www.linkedin.com/in/nikhil-naredi-64a2082/?originalSubdomain=in',
            },
            {
              name: 'Trishita Dasgupta',
              position: 'Counsel, Shardul Amarchand Mangaldas & Co',
              image:
                'https://static.levocdn.com/WGLBUT82/TrishitaDasgupta1R-WT06rjNQpAFF.JPG',
              linkedIn:
                'https://www.linkedin.com/in/trishita-dasgupta-b8892724/?originalSubdomain=in',
            },
            {
              name: 'Neha Sahgal',
              position: 'Senior Associate, Shardul Amarchand Mangaldas & Co',
              image:
                'https://static.levocdn.com/WGLBUT82/NehaSahgal-74dyDESCOlXV.jpeg',
              linkedIn:
                'https://www.linkedin.com/in/nehasahgal96/?originalSubdomain=in',
            },
          ].map((item, index) => (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
              <Flex
                key={index}
                flexDir={{ xs: 'column', sm: 'row', md: 'column' }}
                columnGap="20px"
                rowGap="16px"
              >
                <Flex
                  flexDir="column"
                  alignItems={{ xs: 'center', sm: 'flex-start' }}
                  rowGap="8px"
                >
                  <Box boxSize="95px" borderRadius="50%" overflow="hidden">
                    <Avatar
                      name={item.name}
                      w="100%"
                      h="100%"
                      src={item.image}
                      objectFit="cover"
                    />
                  </Box>
                  <Flex flexDir="column" rowGap="4px">
                    <Flex
                      alignItems="center"
                      gap="12px"
                      justifyContent={{ xs: 'center', md: 'start' }}
                    >
                      <Heading
                        variant="blogQuestion"
                        textAlign={{ xs: 'center', sm: 'left' }}
                      >
                        {item.name}
                      </Heading>
                      <Link href={item?.linkedIn} target="_blank">
                        <IconButton
                          aria-label="linkedin"
                          icon={<FaLinkedin size="28px" color="#067acc" />}
                          variant="unstyled"
                          cursor="pointer"
                        />
                      </Link>
                    </Flex>
                    <Text
                      variant="blogAnswer"
                      textAlign={{ xs: 'center', sm: 'left' }}
                      fontStyle="italic"
                    >
                      {item.position}
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
            </>
          ))}
        </Flex>
        <Box w={{ xs: '100%', md: '73%' }}>
          <Text variant="blogAnswer" mb="20px">
            In recent years, the Indian capital markets has seen significant
            fund-raising activity from start-ups, especially new-age technology
            companies including household names such as FirstCry, Ixigo, Paytm,
            PB Fintech and Swiggy. <br />
            <br />
            With each round of investments raised by start-ups, not only do the
            shareholding of the founder promoters get diluted, they typically
            also no longer remain in ‘control’ of such companies, which
            ultimately, more often than not, result in them ceasing to be
            classified as ‘promoters’ of the companies. The ‘founders’ generally
            continue with the company as professional executives, under the
            guidance and supervision of the board of directors. <br />
            <br />
            In order to keep the founders incentivized in the long run despite
            the dilution in their shareholding and to avoid cash flow strains
            (attributable to enhanced managerial remuneration) on the company,
            the investors and the management of the company tend to offer
            employee stock options
            <strong>(“ESOPs”)</strong>
            to founders to boost their holdings and drive them to scale up their
            ventures for a longer term. Such ESOPs are typically performance
            linked incentives offered to the founders to keep them motivated and
            invested in a company. The founders usually operate and function as
            professionals and hold minority shareholding in the company with a
            significant portion being in the form of performance-based
            incentives like ESOPs.
          </Text>
          {/* Bold */}
          <Box w={{ xs: '100%', md: '73%' }}>
            <Text variant="blogAnswer" mb="20px" fontWeight="800">
              The Shift in Promoter Classification
            </Text>
          </Box>
          <Box w={{ xs: '100%' }}>
            <Text variant="blogAnswer" mb="20px">
              The definition of “promoter” under the Companies Act, 2013 and
              Securities and Exchange Board of India (Issue of Capital and
              Disclosure Requirements) Regulations, 2018 do not prescribe any
              brightline tests in terms of shareholding for determination of
              control. However, in the context of IPO-bound companies, the
              accepted market practice was that only if individuals (along with
              immediate relatives) / entities held more than 25% of the equity
              capital or voting rights of an issuer post-listing, then such
              individuals and/or entities will be required to be identified as
              promoters. Further, companies which did not have any identifiable
              promoter under the above criteria were also allowed to undertake
              an IPO as a company with ‘no identifiable promoter’ subject to
              certain disclosure requirements prescribed in the SEBI
              regulations.
              <br />
              <br />
              However, recently such approach has been revised{' '}
              <strong> (“Revised Approach”)</strong> for IPO-bound companies,
              pursuant to which inter-alia founder(s) will be classified as
              promoter(s) in the event they:
              <br />
              <br />
              <List spacing={3}>
                <ListItem>
                  <strong>a) </strong>
                  Hold a position or have the right to be nominated, as a
                  director or key managerial personnel / senior management.
                </ListItem>
                <ListItem>
                  <strong>b) </strong>
                  Have a collective shareholding of 10% or more of the equity
                  shares (including options which are vested till the date of
                  listing) of the issuer, either directly or through any legal
                  entities or persons controlled by such founder or their
                  immediate relatives. <br />
                  <br />
                </ListItem>
              </List>
              For the purposes of calculating the above shareholding, all
              founders and their respective immediate relatives are considered
              together, and shareholding is taken on a fully diluted basis.
            </Text>
          </Box>
          <Box w={{ xs: '100%' }}>
            <Text variant="blogAnswer" mb="20px" fontWeight="800">
              The ESOP Dilemma
            </Text>
            <Text variant="blogAnswer" mb="20px">
              Owing to the ESOPs granted to the founders, the founders of
              typically end up holding more than 10% of the company on a fully
              diluted basis. Several companies have pre-existing schemes where
              founders (who were not treated as ‘promoters’ prior to the Revised
              Approach being operationalized) hold substantial portion of ESOPs.
              Typically, such IPO-bound companies are required to take
              appropriate corporate actions to designate such founders as
              ‘promoters’ in accordance with the Revised Approach. In terms of
              the applicable laws, promoters are not entitled to receive ESOPs.{' '}
              <br /> <br />
              Consequently, the eligibility of such founders to continue to
              participate in the ESOP programme of the company comes under
              question and requires regulatory clarity. In these cases, grant of
              such ESOPs to the founders (as employees of the company) were in
              line with extant regulations at such time, and the Revised
              Approach results in retrospective adverse results on a validly
              undertaken transaction.
            </Text>
          </Box>
          <Box w={{ xs: '100%' }}>
            <Text variant="blogAnswer" mb="20px" fontWeight="800">
              Implications for Founders and Companies
            </Text>
            <Text variant="blogAnswer" mb="20px">
              If founders are forced to unwind the ESOPs prior to the filing of
              the draft offer document, not only would it materially and
              adversely affect the interest of founders, it may have cascading
              effect on the company’s overall business and may also discourage
              founders from exploring public listing. <br /> <br />
              Accelerated vesting and exercise of ESOPs prior to classification
              as ‘promoter’ since the “promoters” are not included within the
              ambit of the term ‘employee’ is also not a viable option for the
              founders as it may cause unexpected financial and economic burden
              and would also not be in the best interest of such companies.{' '}
              <br /> <br />
              The above-mentioned shift in the regulatory landscape could have
              far-reaching consequences, potentially stifling the very
              innovation and entrepreneurship that India’s start-up ecosystem
              thrives on. It is imperative that SEBI should consider providing
              requisite respite to the founders and allow them to continue to
              hold and exercise such options granted to the founders prior to
              them being categorized as “promoters” in line with the Revised
              Approach. The Securities and Exchange Board of India (Share Based
              Employee Benefits and Sweat Equity) Regulations, 2021 already have
              room for grandfathering previously granted options in certain
              events, which can be explored in such cases as well. <br /> <br />
              Clear guidelines allowing for the continued participation of
              founders in ESOPs, even after being classified as promoters, would
              help ensure that the capital markets remain attractive for the
              next generation of innovators. <br />
              <br />
              SEBI’s prompt intervention is necessary to safeguard the interests
              of founders, employees, and investors alike and to address this
              conundrum.
            </Text>
          </Box>
        </Box>
        {/*  */}
      </Flex>

      <Box w="100%" h="1.5px" mt="16px" mb="8px" bgColor="gray.700" />
      <Text variant="blogAnswer" fontStyle="italic" p="12px 12px 0px">
        <Heading variant="blogQuestion" fontStyle="normal" as="span">
          #TheContext by IVCA{' '}
        </Heading>
        – features opinion makers from the alternate investing industry with
        strong focus on India as investment destination. Watch this space for
        viewpoints on investment themes, emerging trends, economic analysis and
        latest industry insights.
      </Text>
      <Heading
        variant="blogQuestion"
        lineHeight="30px"
        pt="16px"
        fontStyle="italic"
        p="12px 12px 0px"
      >
        Content in this section is curated by team IVCA. To share feedback,
        connect with &nbsp;
        <Link
          href="mailto:paromita.sinha@ivca.in"
          target="_blank"
          style={{ color: 'blue', textDecoration: 'underline' }}
        >
          paromita.sinha@ivca.in
        </Link>
      </Heading>
    </Container>
  </>
);

export default TheContextBalancingFounderBlog;
